module.exports = __webpack_public_path__ + "img/女-结直肠癌h.72f2e4cc.png";